import { useUnit } from 'effector-react';
import _ from 'lodash';
import $$ep from 'models/ep';
import { $global } from 'models/store-global';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import HookSelectFormControl from '../HookSelectFormControl';

import ControlsDataService from 'services/ControlsDataService';
import ModalsService from 'services/ModalsService';

import useResources from 'hooks/useResources';

import { State } from 'types/zod/controls-data';

export interface ISelectItem {
    value: any;
    title: string;
}

interface HookStateFormControlProps {
    name: string;
    statesToSkip?: string[];
    [key: string]: any;
}

const HookStateFormControl = (props: HookStateFormControlProps) => {
    const { statesToSkip = [] } = props;

    const form = useFormContext();
    const oldValue = form.getValues(props.name) || '';

    const [originatorId, spouseId] = useUnit($global.map((state) => state?.community?.tabs || []));
    const isSingle = useUnit($$ep.$isSingle);

    const [states, setStates] = useState<State[]>([]);
    const { t } = useResources();

    useEffect(() => {
        (async () => {
            const controlsData = await ControlsDataService.get(['states']);
            setStates(controlsData?.states ?? []);
        })();
    }, []);

    const participantId = form.getValues('participant_id');
    const shouldShowModal =
        !!participantId && (participantId === originatorId || (!isSingle && participantId === spouseId));

    return (
        <HookSelectFormControl
            {..._.omit(props, 'statesToSkip')}
            name={props.name}
            items={states.filter((s) => !statesToSkip.includes(s.code)).map((s) => ({ value: s.code, title: s.name }))}
            addEmptyItem={true}
            emptyItemTitle={t('ui.selectPlaceHolder.state')}
            onChange={(event: any) => {
                const newValue = event.target.value;
                const isAuthorized = $global.map((state) => state.auth?.isAuthenticated).getState() === true;
                if (newValue !== oldValue && isAuthorized) {
                    if (shouldShowModal) {
                        ModalsService.showModality(t('updateStateModality.title'), t('updateStateModality.body'), {
                            confirmButton: t('updateStateModality.confirmButton'),
                            closeButton: t('updateStateModality.closeButton'),
                            onCancel: () => {
                                form.setValue(props.name, oldValue);
                            },
                        });
                    } else {
                        form.setValue(props.name, newValue);
                    }
                }
            }}
        />
    );
};

export default HookStateFormControl;
